import * as z from 'zod';

export const RequirementsSchemaFaq = z.object({
  name: z.string().min(1, { message: 'Nome é obrigatório.' }),
  email: z.string().email({ message: 'Email inválido.' }),
  category: z.string().min(1, { message: 'Categoria é obrigatório.' }),
  subject: z.string().min(1, { message: 'Assunto é obrigatório.' }),
  message: z.string().min(1, { message: 'Mensagem é obrigatório.' }),
});
